export default __webpack_public_path__ + "static/media/photo--lg--matt-2.48665874.jpg";